export interface PlaybackDisplayState {
  lineId: string;
  speaking: boolean;
}

/** Line and speaking-state changes alter controls; word progress does not. */
export function playbackUpdateRequiresFullRender(current: PlaybackDisplayState, next: PlaybackDisplayState): boolean {
  return current.lineId !== next.lineId || current.speaking !== next.speaking;
}

export function playbackProgress(position: number, lineCount: number): { lineLabel: string; percentLabel: string } {
  const count = Math.max(1, lineCount);
  const current = Math.max(0, Math.min(count - 1, position));
  return {
    lineLabel: `Line ${current + 1} of ${lineCount}`,
    percentLabel: `${Math.round(((current + 1) / count) * 100)}%`,
  };
}
